import { Cover } from "@components/anti/Cover"
import { imgUrl } from "src/mixins"

function LocationDetailMovies({ data, url, locale }) {
  return (
    <section className="sc-location-detail-movies">
      <Cover
        img={imgUrl(data?.bg_desktop)}
        imgMd={imgUrl(data?.bg_mobile)}
        imgHeight="h-vh-100"
        label=""
        title={locale === "en" ? data?.title_en : data?.title}
        text={locale === "en" ? data?.description_en : data?.description}
        buttons={[
          {
            text: data && data[`button_label_${locale}`],
            link: { url: url || data?.button_url },
            variant: "primary-light",
            target: "_blank",
          },
        ]}
      />
    </section>
  )
}

export default LocationDetailMovies
